export const CONTENT_CARD_LOCATIONS = {
  HOME_SIDE_CARD_1: 'home_side_card_1',
  HOME_SIDE_CARD_2: 'home_side_card_2',
}
